var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-2 ml-2 d-flex flex-column card-container"},[_c('span',{staticClass:"card-number",style:({'color':_vm.textColor})},[_vm._v(_vm._s(_vm.number))]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('span',{staticClass:"card-subtitle"},[_vm._v(_vm._s(_vm.description))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe892276","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardCard.vue
// module id = null
// module chunks = 